export const FETCH_PROVIDER_CARE_CONVERSATIONS = 'FETCH_PROVIDER_CARE_CONVERSATIONS';
export const FETCH_PATIENT_CARE_CONVERSATION_OBJ = 'FETCH_PATIENT_CARE_CONVERSATION';
export const CHAT_LOADER = 'CHAT_LOADER';
export const SEND_CARE_MESSAGES = 'SEND_CARE_MESSAGES';
export const FETCH_PATIENT_CARE_MESSAGES = 'FETCH_PATIENT_CARE_MESSAGES';
export const ACTIVE_CHAT = 'ACTIVE_CHAT';
export const PROVIDER_SEARCH = 'PROVIDER_SEARCH';
export const START_PROVIDER_CHAT = 'START_PROVIDER_CHAT';
export const SEND_PROVIDER_CONV_MESSAGES = 'SEND_PROVIDER_CONV_MESSAGES';
export const FETCH_PROVIDER_TO_PROVIDER_CONVERSATIONS = 'FETCH_PROVIDER_TO_PROVIDER_CONVERSATIONS';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const PATIENT_CHAT_SEARCH = 'PATIENT_CHAT_SEARCH';
export const RESET_CHAT_WINDOW = 'RESET_CHAT_WINDOW';

